export function topUpCommission(amount: number, bps: number): number {
  if (!Number.isInteger(amount) || amount < 1 || bps <= 0) return 0;
  return Math.ceil((amount * bps) / 10_000);
}

export function topUpTotal(amount: number, bps: number): number {
  return amount + topUpCommission(amount, bps);
}

export function rubToStars(rub: number, minorPerStar: number): number {
  if (!Number.isInteger(rub) || rub < 1 || minorPerStar < 1) return 1;
  return Math.max(1, Math.ceil((rub * 100) / minorPerStar));
}

export function topUpDisplayRange(product: { topUpMinRub?: number | null; topUpMaxRub?: number | null }): {
  min: number;
  max: number | null;
} {
  return {
    min: product.topUpMinRub != null && product.topUpMinRub > 0 ? product.topUpMinRub : 0,
    max: product.topUpMaxRub != null && product.topUpMaxRub > 0 ? product.topUpMaxRub : null,
  };
}

export function topUpPayRange(product: { topUpMinRub?: number | null; topUpMaxRub?: number | null }): {
  min: number;
  max: number;
} {
  const { min, max } = topUpDisplayRange(product);
  return { min: Math.max(1, min), max: max ?? 10_000_000 };
}

export function isValidTopUpAmount(
  amount: number,
  product: { topUpMinRub?: number | null; topUpMaxRub?: number | null },
): boolean {
  if (!Number.isInteger(amount)) return false;
  const { min, max } = topUpPayRange(product);
  return amount >= min && amount <= max;
}

export function formatTopUpRange(product: { topUpMinRub?: number | null; topUpMaxRub?: number | null }): string {
  const { min, max } = topUpDisplayRange(product);
  const from = `от ${min} ₽`;
  const to = max == null ? 'до ∞' : `до ${max.toLocaleString('ru-RU')} ₽`;
  return `${from} ${to}`;
}

export function isTopUpProduct(product: {
  isTopUp?: boolean;
  category?: { slug?: string | null; title?: string | null } | null;
}): boolean {
  if (product.isTopUp) return true;
  const slug = product.category?.slug ?? '';
  const title = product.category?.title ?? '';
  return slug.includes('popolnen') || /пополнен/i.test(title);
}
